/* eslint-disable no-underscore-dangle */

/**
 * 访问埋点
 * @param client 端：pc、mobile
 * @param channelCode 渠道：如atv
 * @param page 页面路由：如login
 */
function pageView(pageParams = {}) {
  if (!window._ssa) {
    return;
  }
  document.querySelector('#pagename').value = JSON.stringify(pageParams);
  window._ssa.pageViewInit();
}

/**
 * 自定义埋点
 * @param eid 自定义事件名称
 * @param evi 自定义事件信息
 */
function sendSsaData(eid, evi = {}) {
  if (!window._ssa) {
    return;
  }
  const dataValue = {
    eid,
    evi: JSON.stringify(evi),
  };
  window._ssa.sendData(window._ssa.dataType.custom, dataValue);
}

export {
  pageView,
  sendSsaData,
};
